import Pattern from '../ASSETS/MindShapesPattern.png';

export const Background = `radial-gradient(transparent, black 100%), url(${Pattern})`;
